module.exports = __webpack_public_path__ + "static/media/rapidNaming-norming-intro1.e265be33.mp3";